export default __webpack_public_path__ + "static/media/google-icon.b7d6622f.svg";